const bazarNp = {
  common: {
    brandLabel: 'ब्रान्ड',
    storeLabel: 'स्टोर',
    unitCount: 'वटा',
  },
  search: {
    placeholders: [
      'प्रोडक्टको नाम टाइप गर्नुहोस्...',
      'ब्रान्डको नाम टाइप गर्नुहोस्...',
      'स्टोरको नाम टाइप गर्नुहोस्...',
      'क्याटागोरीको नाम टाइप गर्नुहोस्...'
    ]
  },
  sidebar: {
    categoriesTitle: 'क्याटागोरी',
    storesTitle: 'स्टोर सूची',
  },
  store: {
    serviceAreaLabel: 'सेवा क्षेत्र',
    nationwide: 'साराभरि',
    productCount: 'वस्तु',
    productsOfSuffix: 'का वस्तुहरू',
    description: 'यस स्टोरका सबै उपलब्ध वस्तुहरू तल देखाइएको छ। तपाईँ क्याटागोरी अनुसार फिल्टर गर्न सक्नुहुन्छ।',
  },
  buttons: {
    details: 'विवरण',
    addToCart: 'कार्टमा राख्नुहोस्',
    clearFilters: 'सबै फिल्टर हटाउनुहोस्',
    close: 'बन्द गर्नुहोस्',
  },
  empty: {
    title: 'कुनै वस्तु फेला परेन',
    subtitle: 'कृपया फिल्टर वा खोजाई परिवर्तन गर्नुहोस्',
  },
};

export default bazarNp;


